import { render, staticRenderFns } from "./is-gift.vue?vue&type=template&id=ee743fea&scoped=true&"
import script from "./is-gift.vue?vue&type=script&lang=js&"
export * from "./is-gift.vue?vue&type=script&lang=js&"
import style0 from "./is-gift.vue?vue&type=style&index=0&id=ee743fea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee743fea",
  null
  
)

export default component.exports